<template>
  <div class="pdf-viewer-wrapper" >
    <v-toolbar dense class="pdf-toolbar">
      <v-spacer></v-spacer>
      <v-btn plain @click.native.stop="rotate"><!-- rotation -->
        <v-icon>screen_rotation_alt</v-icon>
      </v-btn>
      <v-btn plain :disabled="width >= 1900" @click.native.stop="zoomIn"><!-- + -->
        <v-icon>zoom_in</v-icon>
      </v-btn>
      <v-btn plain :disabled="width <= 540" @click.native.stop="zoomOut"><!-- - -->
        <v-icon>zoom_out</v-icon>
      </v-btn>

      <v-checkbox
          class="show-all-pages"
          v-model="isAllShow"
          :label="$t('common:all-pages')"
      ></v-checkbox>

      <div v-if="!isAllShow">
        <v-btn :disabled="currentPage <= 1"  plain @click.native.stop="goBack"><!-- back -->
          <v-icon>arrow_back_ios</v-icon>
        </v-btn>
        {{currentPage}}/{{pageCount}}
        <v-btn plain  :disabled="currentPage >= pageCount" @click.native.stop="goForward"><!-- forward -->
          <v-icon>arrow_forward_ios</v-icon>
        </v-btn>
      </div>
      <v-btn plain @click.native.stop="$emit('downloadFile')"><!-- download -->
        <v-icon>download</v-icon>
      </v-btn>
      <v-btn plain @click.native.stop="print"><!-- print -->
        <v-icon>print</v-icon>
      </v-btn>
    </v-toolbar>
    <v-overlay
        :value="isLoading"
        absolute
    >
      <v-progress-circular
          indeterminate
          size="64"
      ></v-progress-circular>
    </v-overlay>
    <vue-pdf-embed
        v-show="!isLoading"
        ref="pdfViewer"
        :width="width"
        :scale="scale"
        :rotation="rotation"
        :page="currentPage"
        @rendered="handleDocumentRender"
        class="pdf-viewer-window" :source="src" />
  </div>
</template>

<script>
export default {
  name: 'PdfViewer',
  components: {
    VuePdfEmbed: () => import('vue-pdf-embed/dist/vue2-pdf-embed'),
  },
  props: {
    src: String
  },
  data() {
    return {
      rotation: 0,
      currentPage: 1,
      pageCount: 1,
      width: 740,
      scale: 5.1,
      isLoading: true,
      isScrollingAction: false,
      isAllShow: false
    }
  },
  watch: {
    isAllShow() {
      this.currentPage = this.isAllShow ? null : 1;
    }
  },
  methods: {
    handleDocumentRender() {
      this.isLoading = false;
      this.pageCount = this.$refs.pdfViewer.pageCount;
      if(this.isScrollingAction) {
        this.isScrollingAction = false;
        document.getElementById('pdfWrapper').scrollTop = 10;
      }
    },
    rotate() {
      if (this.isLoading) return;
      this.isLoading = true;
      if (this.rotation == 270) {
        this.rotation = 0;
        return;
      }

      this.rotation += 90;
    },
    goForward() {
      if (this.isLoading || this.currentPage >= this.pageCount) return;
      this.isLoading = true;
      this.currentPage++;
    },
    goBack() {
      if (this.isLoading || this.currentPage <= 1) return;
      this.isLoading = true;
      this.currentPage--;

    },
    zoomIn() {
      if (this.isLoading) return;
      this.isLoading = true;
      this.scale += 0.5;
      this.width += 100;
    },
    zoomOut() {
      if (this.isLoading) return;
      this.isLoading = true;
      this.scale -= 0.5;
      this.width -= 100;
    },
    print() {
      this.$refs.pdfViewer.print();
    }
  }
}
</script>

<style lang="scss">
 .pdf-viewer-wrapper {
   overflow: auto;
   height: 100%;
   width: 100%;

   .pdf-toolbar {
     position: absolute;
     top: 0;
     left: 0;
     z-index: 9999;
     width: 100%;
   }

   .v-toolbar__content {
     padding: 0;
   }
   .v-btn:not(.v-btn--round).v-size--default {
     height: 36px;
     min-width: 40px;
     padding: 0;
     margin: 0;
   }
 }

 .pdf-viewer-window {
   margin-top: 50px;
 }
 .show-all-pages {
   .v-input__slot {
     margin-top: 12%;
   }
 }

</style>